<template>
  <div>
    <el-row type="flex" justify="center" align="middle">
      <el-col :span="24" style="width: 1280px; height: 78px;">
        <el-row type="flex" justify="center" align="middle" style="height: 78px;">
          <el-col :span="8" style="text-align: center;"><img src="./assets/logo.png"></el-col>
          <el-col :span="4">
            <router-link to="/">
              <div :class="$router.history.current.path=='/' ? 'link-selected' : 'link'">首页</div>
            </router-link>
          </el-col>
          <el-col :span="4">
            <router-link to="/product">
              <div :class="$router.history.current.path=='/product' ? 'link-selected' : 'link'">产品与服务</div>
            </router-link>
          </el-col>
          <el-col :span="4">
            <router-link to="/about">
              <div :class="$router.history.current.path=='/about' ? 'link-selected' : 'link'">关于我们</div>
            </router-link>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <router-view></router-view>
    <el-divider></el-divider>
    <el-row type="flex" justify="center" align="middle">
      <el-col :span="24" style="width: 800px; height: 56px;">
        <el-row type="flex" justify="center" align="middle" style="height: 56px;">
          <el-col :span="4">
            <router-link to="/">
              <div class="link-bottom">首页</div>
            </router-link>
          </el-col>
          <el-col :span="4">
            <router-link to="/product">
              <div class="link-bottom">产品与服务</div>
            </router-link>
          </el-col>
          <el-col :span="4">
            <router-link to="/about">
              <div class="link-bottom">关于我们</div>
            </router-link>
          </el-col>
        </el-row>
        <el-row type="flex" justify="center" align="middle" style="height: 20px;">
          <el-col>
            <div style="text-align: center; font-size: 18px; color: #999999;">
              办公地址：成都市温江区光华大道三段1588号1栋30层3001-3017号
            </div>
          </el-col>
        </el-row>
        <br>
        <el-row type="flex" justify="center" align="middle" style="height: 56px;">
          <el-col :span="24"><a href="https://h5.shantaijk.cn/pagemaker-cms/#/h5?tid=bld4XRzL" target="_blank">
            <div style="text-align: center; font-size: 18px; color: #999999;">
              <img style="width:30px;" src="./assets/businessLicense.jpg" alt="成都杉泰营业执照"><br>
              成都杉泰营业执照
            </div>
          </a>
          </el-col>
        </el-row>
        <el-row type="flex" justify="center" align="middle" style="height: 56px;">
          <el-col :span="8">
            <div style="text-align: right; font-size: 18px; color: #999999;">Copyright &copy; www.tygit.cn</div>
          </el-col>
          <el-col :span="8"><a href="https://beian.miit.gov.cn/">
            <div style="text-align: center; font-size: 18px; color: #999999;">蜀ICP备2021012907号</div>
          </a></el-col>
          <el-col :span="8"><a>
            <div style="text-align: left; font-size: 18px; color: #999999;">联系电话：021-34249030</div>
          </a></el-col>
        </el-row>
        <el-row type="flex" justify="center" align="middle" style="height: 56px;">
          <el-col :span="24"><a href="https://h5.shantaijk.cn/pagemaker-cms/#/h5?tid=NMgGbGhc" target="_blank">
            <div style="text-align: center; font-size: 18px; color: #999999;">成都杉泰互联网医院执业许可证：MAACFEWH951011517D1102</div>
          </a>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
a {
  text-decoration: none;
}

a:visited {
  text-decoration: none;
}

a:hover {
  text-decoration: none;
}

a:active {
  text-decoration: none;
}

.link {
  text-align: center;
  font-size: 18px;
  color: #333333;
  height: 78px;
  line-height: 78px;
}

.link-selected {
  text-align: center;
  font-size: 18px;
  color: #FFFFFF;
  height: 78px;
  line-height: 78px;
  background-image: linear-gradient(7deg, #02C0CB 0%, #0ADDA4 100%);
}

.link-bottom {
  text-align: center;
  font-size: 22px;
  color: #333333;
  height: 56px;
  line-height: 56px;
}
</style>
